import * as React from 'react';
import { Prompt } from 'react-router';
import { get } from 'lodash';
import { reduxForm } from 'redux-form';
import { Grid, Row, Col } from 'react-flexbox-grid';
import { compose, withProps } from 'recompose';
import { format } from 'date-fns';
import { Card } from 'material-ui/Card';

import { breadcrumbs } from '@inqool/uas-web-core/es/utils';
import Button from '@inqool/uas-web-core/es/components/controls/Button';
import { entityDetailEnhancer } from '@components/hoc/entityDetailEnhancer';
import { InputField, Input } from '@components/form';

import { getRequestPay } from '@modules/hr-requests/pays/_requestsPayActions';
import * as T from '@modules/hr-requests/pays/_requestsPayTypes';
import { required } from '@utils/validators';

export const enhance = compose<T.RequestPayFormProps, T.OutterProps>(
  entityDetailEnhancer<T.RequestPayEnhancerProps<T.RequestPay>, T.RequestPay>({
    getEntity: getRequestPay,
    defaultEntity: {}
  }),
  breadcrumbs(() => [{ label: 'Detail' }]),
  withProps<{}, T.RequestPayFormProps>(({ entity }) => ({
    initialValues: {
      ...entity
    },
    isEdit: !!get(entity, 'id', false),
    maxYear: format(new Date(), 'YYYY')
  })),
  reduxForm({
    form: 'module-tickets'
  })
);

export const View: React.SFC<T.InnerProps & T.OutterProps & T.RequestPayFormProps> = ({
  closeItem,
  isEdit,
  ...props
}) => (
  <div>
    <Prompt
      when={props.dirty && !props.submitSucceeded && !props.submitting}
      message="Vaše změny nebyly uloženy, přesto odejít?"
    />
    <form className="layout" onSubmit={props.handleSubmit}>
      <Card>
        <Grid fluid={true}>
          <Row>
            <Col className="grid-system-margin" />
          </Row>
          <Row>
            <Col md={12}>
              <InputField
                component={Input}
                multiLine={true}
                rowsMax={10}
                name="description"
                id="description"
                label={'Popis *'}
                style={{ maxHeight: '60vh' }}
                inputStyle={{ maxHeight: '60vh' }}
                disabled={isEdit}
                textareaStyle={{ maxHeight: '56vh' }}
                validate={required}
              />
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <InputField
                component={Input}
                name="hoursToPay"
                id="hoursToPay"
                label={'Hodiny k zaplacení *'}
                disabled={isEdit}
                type="number"
                validate={required}
              />
            </Col>
          </Row>
          {isEdit && (
            <Row>
              <Col md={12}>
                <InputField
                  component={Input}
                  multiLine={true}
                  rowsMax={10}
                  name="response"
                  id="response"
                  label={'Odpověď'}
                  style={{ maxHeight: '60vh' }}
                  inputStyle={{ maxHeight: '60vh' }}
                  textareaStyle={{ maxHeight: '56vh' }}
                />
              </Col>
            </Row>
          )}
        </Grid>
        {isEdit ? (
          // TODO onClick
          <React.Fragment>
            <Button label="Potvrdit" primary={true} style={{ margin: '16px 0 16px 16px' }} onClick={null} />
            <Button label="Zamítnout" primary={true} style={{ margin: '16px 0 16px 16px' }} onClick={null} />
          </React.Fragment>
        ) : (
          <Button type="submit" label="Uložit a zavřít" primary={true} style={{ margin: '16px 0 16px 16px' }} />
        )}
        <Button label="Zrušit" style={{ margin: '16px 0 16px 16px' }} onClick={closeItem} />
      </Card>
    </form>
  </div>
);

export const RequestsPayForm = enhance(View);



// WEBPACK FOOTER //
// ./src/modules/hr-requests/pays/RequestsPayForm.tsx